<div class="footer">
  <div class="footer__content">
    <div class="footer__info">
      <ul class="footer__links">
        <li class="footer__item">
          <a class="footer__link" href="https://www.massmutual.com/terms-of-use" target="_blank">Terms of Use</a>
        </li>
        <li class="footer__item">
          <a class="footer__link" href="https://www.massmutual.com/legal/privacy" target="_blank">Privacy</a>
        </li>
        <li class="footer__item"><button class="footer__link" routerLink="help">Help</button></li>
      </ul>
      <p class="footer__copyright">
        © {{ copyrightYear }} Massachusetts Mutual Life Insurance Company Springfield, MA 01111-0001. All rights
        reserved.
      </p>
      <p class="footer__meta">
        MassMutual Convertible Term (SCT, and ICC18TFC in certain states, including North Carolina) is a term life
        insurance policy, and MassMutual Whole Life 100 (WL-2018 and ICC18WL in certain states, including North
        Carolina) is a level-premium, participating, permanent whole life insurance policy. Both products are issued by
        Massachusetts Mutual Life Insurance Company (MassMutual), Springfield, MA 01111-0001.
      </p>
      <p class="footer__meta" *ngIf="showCRN">Advisors are licensed insurance agents/brokers. CRN202105-247650</p>
      <p class="footer__meta">V{{ version }}</p>
    </div>
    <div class="footer__logo">
      <img class="footer__logo-image" src="/img/logo/coverpath-logo-gray.svg" alt="Coverpath" />
    </div>
  </div>
</div>
